/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Sample carousel module used for AEM demonstration
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CarouselItemComponent } from './components/carousel-item/carousel-item.component';

@NgModule({
  imports: [CommonModule, CarouselModule],
  declarations: [CarouselComponent, CarouselItemComponent],
  exports: [CarouselComponent],
})
export class TmoCarouselModule {}
